import { cloneDeep } from 'lodash'

export function sortLocais (locais) {
  let locals = []
  locais.map(item => {
    locals.push({ 'nome': item.nome,
                  'cliente': item.codigoSubtenant,
                  'endereco': item.endereco,
                  'sgh': item.codigoSgh,
                  'disablePlan' : item.disablePlan,
                  'hidePlan' : item.hidePlan,
                  'hablitaTelehealth' : item.hablitaTelehealth,
                })
  });
  return locals.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
